import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePermissions } from "@/hooks/usePermissions";
import { Card } from "@/components/ui/card";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export default function Users() {
  const { can, loaded } = usePermissions();
  const [users, setUsers] = useState([]);
  const [role, setRole] = useState("all");
  useEffect(() => {
    if (!loaded || !can("employee.list")) { setUsers([]); return; }
    (async () => {
      try { const { data } = await api.get(`/users${role !== "all" ? `?role=${role}` : ""}`); setUsers(data); }
      catch { setUsers([]); }
    })();
  }, [role, loaded, can]);

  if (loaded && !can("employee.list")) {
    return (
      <div className="space-y-4" data-testid="users-denied">
        <div>
          <div className="eyebrow">User management</div>
          <h1 className="font-display text-3xl font-extrabold text-[#0A2540] tracking-tight mt-1">All users</h1>
        </div>
        <Card className="p-6 border-slate-200 text-sm text-slate-600">
          You don't have permission to list employees. Backend is authoritative — any direct request would return 403.
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow">User management</div>
        <h1 className="font-display text-3xl font-extrabold text-[#0A2540] tracking-tight mt-1">All users</h1>
      </div>
      <div className="max-w-xs">
        <Select value={role} onValueChange={setRole}>
          <SelectTrigger data-testid="users-role-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All roles</SelectItem>
            <SelectItem value="buyer">Buyers</SelectItem>
            <SelectItem value="supplier">Suppliers</SelectItem>
            <SelectItem value="account_manager">Account managers</SelectItem>
            <SelectItem value="admin">Admins</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <Card className="border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr className="text-left text-xs uppercase tracking-wider text-slate-500">
              <th className="px-6 py-3">Name</th>
              <th className="px-6 py-3">Email</th>
              <th className="px-6 py-3">Company</th>
              <th className="px-6 py-3">Role</th>
              <th className="px-6 py-3">Joined</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {users.map((u) => (
              <tr key={u.id}>
                <td className="px-6 py-4 font-medium text-[#0A2540]">{u.name}</td>
                <td className="px-6 py-4 text-slate-600">{u.email}</td>
                <td className="px-6 py-4">{u.company_name}</td>
                <td className="px-6 py-4"><span className="text-xs px-2 py-0.5 bg-slate-100 rounded">{u.role.replace("_", " ")}</span></td>
                <td className="px-6 py-4 text-xs text-slate-500 font-mono-num">{new Date(u.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
